import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useFetch } from "@/hooks/useFetch";

const NONE = "__none__";

// Salesperson picked from Sales Hub > Sales Team; an older free-text value on an existing LM still shows
export function SalespersonSelect({ value, onChange, testid = "salesperson-select", disabled }) {
  const { data } = useFetch("/sales-people?active=true");
  const names = (data || []).map((p) => p.name);
  const all = value && !names.includes(value) ? [value, ...names] : names;
  const known = (n) => !data || names.includes(n);
  return (
    <Select value={value || NONE} onValueChange={(v) => onChange(v === NONE ? "" : v)} disabled={disabled}>
      <SelectTrigger className="bg-white" data-testid={testid}><SelectValue placeholder="Pick from Sales Team" /></SelectTrigger>
      <SelectContent>
        <SelectItem value={NONE}>— None —</SelectItem>
        {all.map((n) => <SelectItem key={n} value={n}>{n}{known(n) ? "" : " (not in Sales Team)"}</SelectItem>)}
      </SelectContent>
    </Select>
  );
}
